
// WhatsApp Service — Store-and-Forward pour messages en instance
export function generateClientMsgId(userId, text) {
  var data = (userId || 'anon') + ':' + text + ':' + Date.now() + ':' + Math.random();
  var hash = 0;
  for (var i = 0; i < data.length; i++) {
    var char = data.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash |= 0;
  }
  return 'wa_' + (userId || 'anon') + '_' + Math.abs(hash).toString(36) + '_' + Date.now().toString(36);
}

export async function checkWorkerStatus() {
  try {
    var res = await fetch('/api/whatsapp/worker-status');
    return await res.json();
  } catch (e) {
    return { online: false, pendingCount: 0 };
  }
}

export async function queueMessage(from, text, clientMsgId, chatJid, isGroup) {
  try {
    var res = await fetch('/api/whatsapp/pending', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ from, text, clientMsgId, chatJid, isGroup: !!isGroup })
    });
    return await res.json();
  } catch (e) {
    return { queued: false, error: e.message };
  }
}

export async function sendWhatsAppMessage(from, text, userId, chatJid, isGroup) {
  var status = await checkWorkerStatus();
  var clientMsgId = generateClientMsgId(userId, text);
  if (status.online) {
    try {
      var res = await fetch('/api/whatsapp/internal-message', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ from, text, clientMsgId, chatJid, isGroup: !!isGroup })
      });
      var data = await res.json();
      return { sent: true, clientMsgId, response: data };
    } catch (e) {
      var q = await queueMessage(from, text, clientMsgId, chatJid, isGroup);
      return { queued: true, clientMsgId, ...q };
    }
  }
  var q = await queueMessage(from, text, clientMsgId, chatJid, isGroup);
  return { queued: true, clientMsgId, message: 'Message mis en attente. Envoi automatique à la reconnexion WhatsApp.', ...q };
}

export function createWhatsAppListener(onOnline, onOffline, onFlush) {
  var lastStatus = null;
  var interval = setInterval(async function() {
    try {
      var status = await checkWorkerStatus();
      if (status.online !== lastStatus) {
        lastStatus = status.online;
        if (status.online && onOnline) onOnline(status);
        else if (!status.online && onOffline) onOffline(status);
      }
      if (status.online && status.pendingCount === 0 && onFlush) onFlush();
    } catch(e) {}
  }, 3000);
  return function() { clearInterval(interval); };
}
